<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="视频id集合对应 zb_vide.id 多个以,分割" prop="videoIds" >
        <a-input v-model="form.videoIds" placeholder="请输入视频id集合对应 zb_vide.id 多个以,分割" />
      </a-form-model-item>
      <a-form-model-item label="zb_exposure_gear.id(套餐id)" prop="gearid" >
        <a-input v-model="form.gearid" placeholder="请输入zb_exposure_gear.id(套餐id)" />
      </a-form-model-item>
      <a-form-model-item label="购买的播放量" prop="paynum" >
        <a-input v-model="form.paynum" placeholder="请输入购买的播放量" />
      </a-form-model-item>
      <a-form-model-item label="订单编号" prop="orderNo" >
        <a-input v-model="form.orderNo" placeholder="请输入订单编号" />
      </a-form-model-item>
      <a-form-model-item label="用户id zb_user.id" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户id zb_user.id" />
      </a-form-model-item>
      <a-form-model-item label="原有播放量" prop="primarynum" >
        <a-input v-model="form.primarynum" placeholder="请输入原有播放量" />
      </a-form-model-item>
      <a-form-model-item label="是否批量发送：0否 1是" prop="isBatch" >
        <a-input v-model="form.isBatch" placeholder="请输入是否批量发送：0否 1是" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getHotRecord, addHotRecord, updateHotRecord } from '@/api/platform/hotRecord'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        videoIds: null,

        gearid: null,

        paynum: null,

        orderNo: null,

        userId: null,

        primarynum: null,

        createTime: null,

        isBatch: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        videoIds: [
          { required: true, message: '视频id集合对应 zb_vide.id 多个以,分割不能为空', trigger: 'blur' }
        ],
        gearid: [
          { required: true, message: 'zb_exposure_gear.id(套餐id)不能为空', trigger: 'blur' }
        ],
        paynum: [
          { required: true, message: '购买的播放量不能为空', trigger: 'blur' }
        ],
        primarynum: [
          { required: true, message: '原有播放量不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        videoIds: null,
        gearid: null,
        paynum: null,
        orderNo: null,
        userId: null,
        primarynum: null,
        createTime: null,
        isBatch: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getHotRecord({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateHotRecord(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addHotRecord(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
